import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  open: boolean;
  title: string;
  body: string;
  onContinue: () => void;
}

export default function EducationalPopup({ open, title, body, onContinue }: Props) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="sm:max-w-md"
        onPointerDownOutside={e => e.preventDefault()}
        onEscapeKeyDown={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="font-heading text-foreground">{title}</DialogTitle>
          <DialogDescription className="sr-only">Educational information</DialogDescription>
        </DialogHeader>
        <div className="text-sm text-muted-foreground space-y-2 py-2">
          {body.split('\n').filter(Boolean).map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
        <Button onClick={onContinue} className="w-full">Continue</Button>
      </DialogContent>
    </Dialog>
  );
}
